export const compactFieldItemSx = {
  height: 28,
  py: 0,
  "& .meta-icon svg, & .drag-icon svg": { width: 18, height: 18 },
};
